import { Environment } from 'Environment';

const id = 46889073;

declare global {
    interface Window {
        ym?: Function;
    }
}

function reachGoal(target: string): void {
    if (typeof window.ym === 'function' && !Environment.isPrivateBuild) {
        try {
            window.ym(id, 'reachGoal', target);
        } catch (reason) {
            // nothing to do
        }
    }
}

export const YandexMetrica = {
    id,
    reachGoal,
};
